<app-side-dialog class="min-w-[700px]">
  <div dialogHeader>
    <h2>{{ title() }}</h2>
  </div>

  <div dialogContent>
    <form class="custom-form flex flex-col gap-10" [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="flex flex-col gap-4">
        <mat-form-field>
          <input matInput cdkFocusInitial formControlName="name" [placeholder]="'field.name' | translate" />
          <mat-error [control]="form.get('name')" [customErrorMessage]="store.nameError$() || ''" />
        </mat-form-field>

        <app-file-uploader
          class="w-full"
          size="big"
          [imageWidth]="80"
          [imageHeight]="80"
          [title]="'components.fileUploader.selectMediaToUploadOptional' | translate"
          [description]="'dialogs.createCustomerDialog.iconDescription' | translate"
          [imageId]="form.controls.iconId.value"
          [fileForm]="form.controls.imageFile"
          [requiredPermission]="[EPermissions.customerCreate]"
          (imageSelected)="onImageSelected($event)"
          (imageRemoved)="onImageRemoved()"
          #fileUploaderComponent
        />
      </div>

      <div class="flex justify-end gap-3">
        <button
          mat-flat-button
          color="secondary-transparent"
          type="button"
          [disabled]="store.customerSubmitLoading$()"
          (click)="onCloseClick()"
        >
          {{ 'shared.cancel' | translate }}
        </button>

        <button
          mat-flat-button
          type="submit"
          data-testid="create-customer-submit"
          [disabled]="!form.valid || store.customerSubmitLoading$()"
        >
          <p [class.hidden]="store.customerSubmitLoading$()">{{ submitButtonText() }}</p>

          @if (store.customerSubmitLoading$()) {
            <app-dots-spinner />
          }
        </button>
      </div>
    </form>
  </div>
</app-side-dialog>
